import Table from "./Table.tsx";

export default Table;
